import React, { useState } from 'react';
import { Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { RESTAURANT, NAV_LINKS } from '../mock';
import Impressum from './Impressum';

export default function Footer() {
  const [impressumOpen, setImpressumOpen] = useState(false);
  return (
    <footer className="border-t border-[rgba(224,180,159,0.15)] bg-[#100d0b] py-14 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="flex flex-col leading-none">
            <span className="font-serif-display text-3xl tracking-[0.22em] text-[#f2ebe3] pl-[0.22em]">{RESTAURANT.name}</span>
            <span className="eyebrow text-[0.62rem] mt-1.5 pl-1">{RESTAURANT.place}</span>
          </div>
          <p className="mt-5 text-[#a99a8b] text-sm leading-relaxed max-w-xs">
            Griechische Küche, warmes Ambiente und mediterrane Gastfreundschaft – mitten in Heideck.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <span className="eyebrow mb-1">Navigation</span>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-[#c3b7aa] hover:text-[#e0b49f] transition-colors w-fit">
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <span className="eyebrow mb-1">Kontakt</span>
          <a href={RESTAURANT.phoneHref} className="flex items-center gap-2.5 text-[#c3b7aa] hover:text-[#e0b49f] transition-colors">
            <Phone size={15} /> {RESTAURANT.phone}
          </a>
          <a href={RESTAURANT.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2.5 text-[#c3b7aa] hover:text-[#e0b49f] transition-colors">
            <MapPin size={15} className="mt-0.5 shrink-0" /> {RESTAURANT.address}
          </a>
          <a href={RESTAURANT.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-[#c3b7aa] hover:text-[#e0b49f] transition-colors">
            <Facebook size={15} /> Reservieren über Facebook
          </a>
          <a href={RESTAURANT.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-[#c3b7aa] hover:text-[#e0b49f] transition-colors">
            <Instagram size={15} /> Instagram @alfaheideck
          </a>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto mt-12 pt-6 border-t border-[rgba(224,180,159,0.1)] flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="text-[#8a7d70] text-xs tracking-wide">© 2026 Restaurant Alfa Heideck. Alle Rechte vorbehalten.</span>
        <div className="flex items-center gap-4">
          <button
            onClick={() => setImpressumOpen(true)}
            className="text-[#8a7d70] text-xs tracking-wide hover:text-[#e0b49f] transition-colors"
          >
            Impressum
          </button>
          <span className="text-[#8a7d70] text-xs tracking-wide">Griechisches Restaurant · Heideck</span>
        </div>
      </div>

      <Impressum open={impressumOpen} onClose={() => setImpressumOpen(false)} />
    </footer>
  );
}
